import * as React from "react"
import { useLocation } from "react-router-dom"

import { resolveNotificationsCentreCategory, resolveNotificationsCentreNotificationId } from "@/constants/notificationsCentre"
import {
  useNotificationsInboxState,
  type NotificationsInboxState,
} from "@/hooks/useNotificationsInbox"

const NotificationsInboxContext = React.createContext<NotificationsInboxState | null>(
  null
)

export type NotificationsInboxProviderProps = {
  children: React.ReactNode
  enabled: boolean
}

export function NotificationsInboxProvider({
  children,
  enabled,
}: NotificationsInboxProviderProps): React.ReactElement {
  const { pathname } = useLocation()
  const categoryFilter = enabled ? resolveNotificationsCentreCategory(pathname) : null
  const selectedNotificationId = enabled
    ? resolveNotificationsCentreNotificationId(pathname)
    : null

  const value = useNotificationsInboxState({
    enabled,
    selectedNotificationId,
    categoryFilter,
  })

  return (
    <NotificationsInboxContext.Provider value={value}>
      {children}
    </NotificationsInboxContext.Provider>
  )
}

export function useNotificationsInbox(): NotificationsInboxState {
  const ctx = React.useContext(NotificationsInboxContext)
  if (!ctx) {
    throw new Error("useNotificationsInbox must be used within NotificationsInboxProvider")
  }
  return ctx
}

export function useOptionalNotificationsInbox(): NotificationsInboxState | null {
  return React.useContext(NotificationsInboxContext)
}
